import React from 'react';
import './FilterBar.css';

/**
 * Reusable FilterBar component for filtering and searching data
 * @param {array} filters - Array of {name, label, type, options, value} objects
 * @param {function} onChange - Filter change handler
 * @param {function} onReset - Reset filters handler
 */
const FilterBar = ({ filters = [], onChange, onReset }) => {
  return (
    <div className="filter-bar">
      <div className="filters-container">
        {filters.map((filter) => (
          <div key={filter.name} className="filter-item">
            {filter.type === 'select' ? (
              <select
                name={filter.name}
                value={filter.value || ''}
                onChange={(e) => onChange(filter.name, e.target.value)}
                className="filter-select"
              >
                <option value="">All {filter.label}</option>
                {filter.options &&
                  filter.options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
              </select>
            ) : filter.type === 'date' ? (
              <input
                type="date"
                name={filter.name}
                value={filter.value || ''}
                onChange={(e) => onChange(filter.name, e.target.value)}
                className="filter-input"
                placeholder={filter.label}
              />
            ) : (
              <input
                type={filter.type || 'text'}
                name={filter.name}
                value={filter.value || ''}
                onChange={(e) => onChange(filter.name, e.target.value)}
                className="filter-input"
                placeholder={filter.label}
              />
            )}
          </div>
        ))}
      </div>

      {onReset && (
        <button onClick={onReset} className="filter-reset">
          Reset Filters
        </button>
      )}
    </div>
  );
};

export default FilterBar;
